import { useEffect } from "react";
import { Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import MainLoader from "../components/loading/MainLoader";
import { getPrivileges } from "../store/actions/auth.action";
import { IRootState } from "../store/configureStore";

const PublicRoute = () => {
  let location = useLocation();
  const dispatch = useDispatch();

  const { isAuthenticated, isAuthLoading, privileges, isLoadingPrivileges } =
    useSelector(({ auth, privileges }: IRootState) => ({
      isAuthenticated: auth.loggedIn,
      isAuthLoading: auth.loading,
      privileges: privileges.dataBundle,
      isLoadingPrivileges: privileges.loading,
    }));

  useEffect(() => {
    if (isAuthenticated && privileges.length === 0) {
      dispatch(getPrivileges());
    }
  }, [isAuthenticated, privileges, dispatch]);

  if (isAuthenticated) {
    return <Navigate to={"/serviceLineUp"} state={{ from: location }} />;
  }

  return (
    <>
      <Col className="public-container">
        <MainLoader
          borderRadius={50}
          minHeight={100}
          show={
            isAuthLoading ||
            isLoadingPrivileges ||
            (isAuthenticated && privileges.length === 0)
          }
        />
        <Outlet />
      </Col>
    </>
  );
};

export default PublicRoute;
